import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "rounded-2xl border border-slate-200/60 bg-white p-6 shadow-sm"
};
const _hoisted_2 = {
  class: "flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between"
};
const _hoisted_3 = {
  class: "min-w-0"
};
const _hoisted_4 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_7 = {
  class: "flex rounded-lg border border-slate-200 bg-slate-50 p-1"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
  key: 0,
  class: "mt-4 rounded-xl border border-dashed border-slate-200 bg-slate-50 p-5 text-center text-sm text-slate-500"
};
const _hoisted_11 = {
  key: 1,
  class: "mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5"
};
import { computed, onMounted } from 'vue';
import { ArrowPathIcon } from '@heroicons/vue/24/outline';
import StatisticMetricCard from './StatisticMetricCard.vue';
import { useDashboardStatistics } from '../composables/useDashboardStatistics';
import { DASHBOARD_STATISTICS_RANGES } from '../utils/statisticsFormat';
export default {
  __name: 'DashboardStatisticsSection',
  setup(__props) {
    const {
      selectedRange,
      loading,
      lastUpdatedAt,
      metricCards,
      hasPermission,
      allVisibleFailed,
      loadStatistics
    } = useDashboardStatistics();
    const rangeLabel = computed(() => {
      return DASHBOARD_STATISTICS_RANGES.find(item => item.value === selectedRange.value)?.label || '近7天';
    });
    function changeRange(value) {
      if (selectedRange.value === value) return;
      selectedRange.value = value;
      loadStatistics();
    }
    onMounted(() => {
      loadStatistics();
    });
    return (_ctx, _cache) => {
      return _unref(hasPermission) ? (_openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "flex items-center gap-2"
      }, [_createElementVNode("div", {
        class: "h-6 w-1.5 rounded-full bg-primary-500"
      }), _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "数据概览")], -1)), _createElementVNode("p", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(rangeLabel.value) + "统计", 1), _unref(lastUpdatedAt) ? (_openBlock(), _createElementBlock("span", _hoisted_5, " · " + _toDisplayString(_unref(lastUpdatedAt)) + " 更新", 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DASHBOARD_STATISTICS_RANGES), range => {
        return _openBlock(), _createElementBlock("button", {
          key: range.value,
          type: "button",
          class: _normalizeClass(["rounded-md px-3 py-1.5 text-xs font-medium transition-colors duration-200", _unref(selectedRange) === range.value ? 'bg-white text-primary-700 shadow-sm' : 'text-slate-500 hover:text-slate-800']),
          onClick: $event => changeRange(range.value)
        }, _toDisplayString(range.label), 11, _hoisted_8);
      }), 128))]), _createElementVNode("button", {
        type: "button",
        class: "inline-flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition-colors duration-200 hover:border-primary-200 hover:bg-primary-50 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-60",
        disabled: _unref(loading),
        title: "刷新统计",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(loadStatistics) && _unref(loadStatistics)(...args))
      }, [_createVNode(_unref(ArrowPathIcon), {
        class: _normalizeClass(["h-4 w-4", {
          'animate-spin': _unref(loading)
        }])
      }, null, 8, ["class"])], 8, _hoisted_9)])]), _unref(allVisibleFailed) ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 统计数据暂时不可用 ")) : (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(metricCards), metric => {
        return _openBlock(), _createBlock(StatisticMetricCard, {
          key: metric.key,
          metric: metric
        }, null, 8, ["metric"]);
      }), 128))]))])) : _createCommentVNode("", true);
    };
  }
};